// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-calendar {
  background: white;
  line-height: 1.125em;
  border-radius: 10px;
  padding: 24px 10px 20px 10px;
}

.react-calendar--doubleView {
  width: 700px;
}

.react-calendar--doubleView .react-calendar__viewContainer {
  display: flex;
  margin: -0.5em;
}

.react-calendar--doubleView .react-calendar__viewContainer > * {
  width: 50%;
  margin: 0.5em;
}

.react-calendar,
.react-calendar *,
.react-calendar *:before,
.react-calendar *:after {
  box-sizing: border-box;
}

.react-calendar button {
  margin: 0;
  border: 0;
  outline: none;
}

.react-calendar button:enabled:hover {
  cursor: pointer;
}

.react-calendar__navigation {
  display: flex;

  height: 44px;
  margin-bottom: 1em;
}

.react-calendar__navigation button {
  min-width: 44px;
  background: none;
  font-size: 24px;
}

.react-calendar__navigation button:disabled {
  background-color: #f0f0f0;
}

.react-calendar__navigation button:enabled:hover,
.react-calendar__navigation button:enabled:focus {
  background-color: #e6e6e6;
}

.react-calendar__month-view__weekdays {
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 0.75em;
}

.react-calendar__month-view__weekdays__weekday {
  padding: 0.5em;
}

.react-calendar__month-view__weekNumbers .react-calendar__tile {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75em;
  font-weight: bold;
}

.react-calendar__month-view__days__day--weekend {
  color: #fc5b5b;
}

.react-calendar__month-view__days__day--neighboringMonth {
  color: #757575;
}

.react-calendar__year-view .react-calendar__tile,
.react-calendar__decade-view .react-calendar__tile,
.react-calendar__century-view .react-calendar__tile {
  padding: 2em 0.5em;
}

.react-calendar__tile {
  max-width: 100%;
  padding: 8px;
  background: none;
  text-align: center;
  line-height: 16px;
  height: 40px;
  position: relative;
}

.react-calendar__tile:disabled {
  background-color: #f0f0f0;
  border-radius: 8px;
}

.react-calendar__tile:enabled:hover,
.react-calendar__tile:enabled:focus {
  background-color: #e6e6e6;
  border-radius: 8px;
}

.react-calendar__tile--now {
  color: #d070fb;
  background: #f8f8f8;
  border-radius: 8px;
}

.react-calendar__tile--now:enabled:hover,
.react-calendar__tile--now:enabled:focus {
  /* background: #ffffa9; */
  border-radius: 8px;
}

.react-calendar__tile--hasActive {
  background: #76baff;
  border-radius: 8px;
}

.react-calendar__tile--hasActive:enabled:hover,
.react-calendar__tile--hasActive:enabled:focus {
  background: #a9d4ff;
  border-radius: 8px;
}

.react-calendar__tile--active {
  background: #236dff;
  /* color: white; */
}

.react-calendar__tile--active:enabled:hover,
.react-calendar__tile--active:enabled:focus {
  background: #236dff;
  color: white;
  border-radius: 8px;
}

.react-calendar--selectRange .react-calendar__tile--hover {
  background-color: #e6e6e6;
}

.react-calendar__navigation {
  display: flex;
  justify-content: space-evenly;
  padding: 0 50px;
}

.react-calendar__navigation__label {
  font-size: 16px !important;
}

.react-calendar__navigation__prev2-button,
.react-calendar__navigation__next2-button {
  display: none;
}

.react-calendar__month-view__weekdays {
  text-align: center;
}

.holiday-marker {
  color: red;
}

abbr[title='토요일'],
.saturday-marker {
  color: blue;
}

abbr[title='일요일'] {
  color: red;
}

abbr:where([title]) {
  -webkit-text-decoration: auto;
          text-decoration: auto;
  font-size: 12px;
}

.react-calendar__month-view__days {
  font-size: 14px;
  color: #6f6f6f;
  font-weight: 400;
}

.dot {
  height: 4px;
  width: 4px;
  background-color: #0054f7;
  border-radius: 50%;
  display: flex;
  margin-left: 1px;
}

.react-calendar__tile--active .dot {
  /* react-calendar__tile--active 클래스가 추가되었을 때 dot 클래스의 스타일 */
  background-color: white;
  height: 4px;
  width: 4px;
  border-radius: 50%;
  display: flex;
  margin-left: 1px;
}
`, "",{"version":3,"sources":["webpack://./src/page/scheduler.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,aAAa;AACf;;AAEA;;;;EAME,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,SAAS;EACT,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;;EAEb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,6BAAqB;UAArB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,2DAA2D;EAC3D,uBAAuB;EACvB,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB","sourcesContent":[".react-calendar {\n  background: white;\n  line-height: 1.125em;\n  border-radius: 10px;\n  padding: 24px 10px 20px 10px;\n}\n\n.react-calendar--doubleView {\n  width: 700px;\n}\n\n.react-calendar--doubleView .react-calendar__viewContainer {\n  display: flex;\n  margin: -0.5em;\n}\n\n.react-calendar--doubleView .react-calendar__viewContainer > * {\n  width: 50%;\n  margin: 0.5em;\n}\n\n.react-calendar,\n.react-calendar *,\n.react-calendar *:before,\n.react-calendar *:after {\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.react-calendar button {\n  margin: 0;\n  border: 0;\n  outline: none;\n}\n\n.react-calendar button:enabled:hover {\n  cursor: pointer;\n}\n\n.react-calendar__navigation {\n  display: flex;\n\n  height: 44px;\n  margin-bottom: 1em;\n}\n\n.react-calendar__navigation button {\n  min-width: 44px;\n  background: none;\n  font-size: 24px;\n}\n\n.react-calendar__navigation button:disabled {\n  background-color: #f0f0f0;\n}\n\n.react-calendar__navigation button:enabled:hover,\n.react-calendar__navigation button:enabled:focus {\n  background-color: #e6e6e6;\n}\n\n.react-calendar__month-view__weekdays {\n  text-align: center;\n  text-transform: uppercase;\n  font-weight: bold;\n  font-size: 0.75em;\n}\n\n.react-calendar__month-view__weekdays__weekday {\n  padding: 0.5em;\n}\n\n.react-calendar__month-view__weekNumbers .react-calendar__tile {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.75em;\n  font-weight: bold;\n}\n\n.react-calendar__month-view__days__day--weekend {\n  color: #fc5b5b;\n}\n\n.react-calendar__month-view__days__day--neighboringMonth {\n  color: #757575;\n}\n\n.react-calendar__year-view .react-calendar__tile,\n.react-calendar__decade-view .react-calendar__tile,\n.react-calendar__century-view .react-calendar__tile {\n  padding: 2em 0.5em;\n}\n\n.react-calendar__tile {\n  max-width: 100%;\n  padding: 8px;\n  background: none;\n  text-align: center;\n  line-height: 16px;\n  height: 40px;\n  position: relative;\n}\n\n.react-calendar__tile:disabled {\n  background-color: #f0f0f0;\n  border-radius: 8px;\n}\n\n.react-calendar__tile:enabled:hover,\n.react-calendar__tile:enabled:focus {\n  background-color: #e6e6e6;\n  border-radius: 8px;\n}\n\n.react-calendar__tile--now {\n  color: #d070fb;\n  background: #f8f8f8;\n  border-radius: 8px;\n}\n\n.react-calendar__tile--now:enabled:hover,\n.react-calendar__tile--now:enabled:focus {\n  /* background: #ffffa9; */\n  border-radius: 8px;\n}\n\n.react-calendar__tile--hasActive {\n  background: #76baff;\n  border-radius: 8px;\n}\n\n.react-calendar__tile--hasActive:enabled:hover,\n.react-calendar__tile--hasActive:enabled:focus {\n  background: #a9d4ff;\n  border-radius: 8px;\n}\n\n.react-calendar__tile--active {\n  background: #236dff;\n  /* color: white; */\n}\n\n.react-calendar__tile--active:enabled:hover,\n.react-calendar__tile--active:enabled:focus {\n  background: #236dff;\n  color: white;\n  border-radius: 8px;\n}\n\n.react-calendar--selectRange .react-calendar__tile--hover {\n  background-color: #e6e6e6;\n}\n\n.react-calendar__navigation {\n  display: flex;\n  justify-content: space-evenly;\n  padding: 0 50px;\n}\n\n.react-calendar__navigation__label {\n  font-size: 16px !important;\n}\n\n.react-calendar__navigation__prev2-button,\n.react-calendar__navigation__next2-button {\n  display: none;\n}\n\n.react-calendar__month-view__weekdays {\n  text-align: center;\n}\n\n.holiday-marker {\n  color: red;\n}\n\nabbr[title='토요일'],\n.saturday-marker {\n  color: blue;\n}\n\nabbr[title='일요일'] {\n  color: red;\n}\n\nabbr:where([title]) {\n  text-decoration: auto;\n  font-size: 12px;\n}\n\n.react-calendar__month-view__days {\n  font-size: 14px;\n  color: #6f6f6f;\n  font-weight: 400;\n}\n\n.dot {\n  height: 4px;\n  width: 4px;\n  background-color: #0054f7;\n  border-radius: 50%;\n  display: flex;\n  margin-left: 1px;\n}\n\n.react-calendar__tile--active .dot {\n  /* react-calendar__tile--active 클래스가 추가되었을 때 dot 클래스의 스타일 */\n  background-color: white;\n  height: 4px;\n  width: 4px;\n  border-radius: 50%;\n  display: flex;\n  margin-left: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
